module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "entity"
  }, [(_vm.content.image) ? _c('h2', {
    staticClass: "entity__title"
  }, [_c('img', {
    staticClass: "entity__title--image",
    attrs: {
      "src": _vm.content.image.url,
      "alt": _vm.content.image.alt
    }
  })]) : _c('h2', {
    staticClass: "entity__title"
  }, [_vm._v(_vm._s(_vm.content.title))]), _vm._v(" "), _c('div', {
    staticClass: "rte"
  }, _vm._l((_vm.content.details), function(item) {
    return _c(item.component, {
      tag: "component",
      attrs: {
        "item": item
      }
    })
  })), _vm._v(" "), (_vm.content.url) ? _c('a', {
    staticClass: "entity__link",
    attrs: {
      "href": _vm.content.url,
      "target": "_blank"
    }
  }, [_vm._v("voir le site "), _c('icon', {
    attrs: {
      "id": 'arrow'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "entity__close",
    attrs: {
      "to": "/ecosysteme",
      "tag": "button"
    }
  }, [_vm._v("×")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fef5b7ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/ecosystem/EntityDetails.vue
// module id = 655
// module chunks = 1